import React from 'react';

import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';


import RegisterForm from './register-form'



const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },

}));


export default ({post_fn,handleClose})=>{

	  const classes = useStyles();
	return(
	<App classes={classes} post_fn={post_fn} handleClose={handleClose}  />
	)
}


  class App extends React.Component {


 render(){

const {classes,post_fn,handleClose }=this.props

  return (




    <Container component="main" maxWidth="xs">

      <div className={classes.paper}>

			{/*<LockOutlinedIcon />*/}


        <Typography component="h1" variant="h5">
          Sign up
        </Typography>
        <div className={classes.form}  >


           <RegisterForm  post_fn={post_fn} handleClose={handleClose}/>



        </div>
      </div>
      <br />

    </Container>



  );
}
}
